import Splide from '@splidejs/splide';
import { Intersection } from '@splidejs/splide-extension-intersection';

export default class Carousel {
	constructor(wrapper) {

		this.ticker 				= wrapper
		this.type					= wrapper.dataset.type
		this.track 					= this.ticker.querySelector('.promo-ticker__group')
		this.init 					= this.init.bind(this)

		if( this.type === 'fader' ) {
			new Splide(wrapper, 
				{
					type: 'fade',
					rewind: true,
					perPage: 1,
					drag: 'true',
					padding: 0,
					pagination: false,
					arrows: false,
					arrowPath: 'M18.6987 41.6554L18.3734 43.29L21.6426 43.9408L21.9679 42.3062C22.4597 39.8355 23.6002 37.3996 25.4705 34.8388L25.4725 34.836C29.1358 29.7984 34.8864 26.0692 40.7015 24.7521L42 24.458L42 19.5722L40.6595 19.3047C37.8023 18.7345 34.8309 17.3905 31.8522 15.2605L31.8485 15.2578C25.7591 10.9286 22.7041 5.65513 21.9725 1.67919L21.6709 0.040039L18.3926 0.643253L18.6942 2.2824C19.6109 7.26432 23.2586 13.2402 29.9152 17.9732C31.1673 18.8685 32.4364 19.6509 33.7163 20.3141L0.333989 20.3141L0.333988 23.6475L33.9031 23.6475C29.569 25.7522 25.6264 28.9571 22.7774 32.8745C20.6923 35.7298 19.3057 38.6058 18.6987 41.6554Z',
				}).mount({
			})
		} else if( this.type === 'timeline' ) {

			let timelinewrapper = wrapper.querySelector('.b-carousel-timeline__slider')
			let timelinetitles = wrapper.querySelector('.b-carousel-timeline__titles')
			const timeline = new Splide(timelinewrapper,
				{
					type: 'loop',
					drag: true,
					perMove: 1,
					autoWidth: true,
					focus: 'center',
					// gap: 16,
					start: 2,
					pagination: false,
					arrows: false,
					rewind: false,
					trimSpace: false,
					omitEnd: true,
					updateOnMove: true,
					autoplay: 'pause',
					speed: 1000,
					interval: 3000,
					breakpoints: {
						767: {
							perPage: 1,
							padding: 16
						},
						1024: {
							perPage: 1,
							padding: 40
						}
					},
					intersection: {
						inView: {
							autoplay: true,
						},
						outView: {
							autoplay: false,
						},
					},
				})

				timeline.on('mounted', function (slide) {
				timelinetitles.classList.add('visible')
			})

			timeline.mount()

			// timelinewrapper.addEventListener('mousedown', () => {
			// 	timelinetitles.classList.remove('visible')
			// 	// console.log('remove class');
			// })

			timeline.on('active', function (slide) {
				timelinetitles.innerHTML = slide.slide.dataset.title;
				timelinetitles.classList.add('visible')
				// console.log('add class');
			})

			timeline.on('click', function (slide, event) {
				if( slide.index === timeline.index )
					return;
				event.preventDefault();
				timeline.go(slide.index);
			});


		} else if( this.type === 'minimal' ) {

			let timelinewrapper = wrapper.querySelector('.b-studios__slider')
			const minimal = new Splide(timelinewrapper,
				{
					type: 'slide',
					drag: true,
					perMove: 3,
					perPage: 3,
					autoWidth: true,
					focus: 'center',
					gap: 32,
					pagination: true,
					arrows: false,
					rewind: false,
					trimSpace: false,
					omitEnd: true,
					updateOnMove: true,
					autoplay: 'pause',
					speed: 500,
					interval: 3000,
					destroy: true,
					breakpoints: {
						599: {
							perPage: 1,
							padding: 16,
							destroy: true,
						},
						1139: {
							perPage: 3,
							padding: 40,
							destroy: false,
						},
						1140: {
							perPage: 3,
							padding: 40,
							destroy: true,
						}
					},
					intersection: {
						inView: {
							autoplay: true,
						},
						outView: {
							autoplay: false,
						},
					},
				})

				minimal.on('mounted', function (slide) {
			})

			minimal.mount()

			minimal.on('click', function (slide, event) {
				if( slide.index === minimal.index )
					return;
				event.preventDefault();
				minimal.go(slide.index);
			});


		} else {
			const splide = new Splide(wrapper, 
				{
					type: 'loop',
					rewind: false,
					perPage: 1,
					drag: 'true',
					perMove: 1,
					autoWidth: true,
					autoHeight: false,
					focus: 'center',
					gap: 80,
					padding: 0,
					start: 1,
					pagination: true,
					arrows: false,
					lazyLoad: 'nearby',
					updateOnMove: true,
					autoplay: true,
					interval: 3000,
					breakpoints: {
						767: {
							gap: 24,
							interval: 120000,
						},
						768: {
							interval: 3000,
						},
						1024: {
							gap: 24,
							interval: 3000,
						}
					}
				}).mount({
			})
			splide.on('click', function (slide, event) {
				if( slide.index === splide.index )
					return;
				event.preventDefault();
				splide.go(slide.index);
			});
		}


	}

	init() {

		

	}
}
